import { Injectable, Inject } from "ng-metadata/core";
import { MappingTablesCache } from '../../../mappingTablesCache/mappingTablesCache.service';
import { ConfigurationUtil } from '../../../nddUtils/configurationUtil.service';
import { getVid } from '../../../appConfig/appConfigForward';
import { ActionListService } from '../actionList.service';
import {ServiceDetailsService} from '../../fullView/details/serviceDetails.service';
import { isEqual } from "lodash";
import { TabsAndScopesSelectorService } from "../../searchBar/tabsAndScopesSelector/tabsAndScopesSelector.service";

@Injectable()
export class ExportAllService {

    private _exportOption:string; //First dropdown chosen value: Excel, RIS or BibTex
    private _encodingOrFormatVal:string; //Second dropdown chosen value: Encoding value or Filetype value
    private EXPORT_ALL_RECORDS = "export_all_records";
    public EXCEL = "Excel";
    public BIBTEXPUSHTO = "BibTeXPushTo";
    public RISPUSHTO = "RISPushTo";
    public default_encoding = "UTF-8";
    public default_filetype = "xlsx";
    public recordsLimit: number = 5000;
    public recordsLimitForBlended: number = 10000;
    public excelHeaders = {};
    public BULK_EXPORT = "bulk_export"; //Primo VE Feature flag identifier


    constructor(private mappingTablesCache: MappingTablesCache,
                private configurationUtil: ConfigurationUtil,
                private actionListService: ActionListService,
                private serviceDetailsService: ServiceDetailsService,
                private tabsAndScopesSelectorService: TabsAndScopesSelectorService,
                @Inject('$q') private $q: ng.IQService,
                @Inject('$translate') private $translate :ng.translate.ITranslateService,
                @Inject('$stateParams') private $stateParams : angular.ui.IStateParamsService) {}

    public isExportAllDisabled(){
        if (this.configurationUtil.getBackendSystem() === 'suprima' && !this.configurationUtil.getFeatureFlag(this.BULK_EXPORT)){
            return true;
        }
        return this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.VIEW_PROPERTIES,{source1: getVid(), source2: this.EXPORT_ALL_RECORDS, target: 'false'}).length > 0
    }

    public isAtLeastOneExportAllActionEnabled(){
        return (this.actionListService.requiredActionsList.includes(this.RISPUSHTO)
            || this.actionListService.requiredActionsList.includes(this.BIBTEXPUSHTO)
            || this.actionListService.requiredActionsList.includes(this.EXCEL));
    }

    public isScopeIncludesLocalOrCDI() { // is the scope includes Local or CDI search scopes
        let tab = this.$stateParams['tab'];
        let searchScope = this.$stateParams['search_scope'];

        if (!tab) {
            tab = this.tabsAndScopesSelectorService.getDefaultTab();
        }
        if (!searchScope) {
            searchScope = this.tabsAndScopesSelectorService.getDefaultSearchScopeForTab(tab);
        }

        let scopesInformation = window.appConfig['primo-view']['scopes'];
        let targetScope = scopesInformation.find(scope => isEqual(scope.tab, tab) && isEqual(scope["scope-id"], searchScope));

        if (!targetScope) {
            return false; // Scope not found, return false
        }

        let locations = targetScope.locations.split(',');

        if (this.configurationUtil.isSuprima()){   //Primo VE
            return locations.some(loc => isEqual('primo_central_multiple_fe', loc) || isEqual('Local', loc));
        }
        else {                              //Classic Primo
            return locations.some(loc => isEqual('primo_central_multiple_fe', loc) || loc.startsWith('scope:('));
        }
    }

    get exportOption() {
        return this._exportOption;
    }

    set exportOption(val){
        this.encodingOrFormatVal=undefined; //reset the encoding/filetype dropdown value
        this._exportOption = val;
        if (isEqual(val, this.EXCEL)){
            this.buildExcelHeadersForPayload();
        }
    }

    get encodingOrFormatVal() {
        return this._encodingOrFormatVal;
    }

    set encodingOrFormatVal(val){
        this._encodingOrFormatVal = val;
    }

    public resetExportAllSelection(){
        this.exportOption = undefined;
        this.encodingOrFormatVal = undefined;
    }

    public buildExcelHeadersForPayload(){
        this.serviceDetailsService.getFieldsForExcel()
            .then(headers => {
                let permalinkHeader = {
                    'order': Object.keys(headers).length,
                    'translation': this.$translate.instant('fulldisplay.command.permalink')
                };
                headers.permalink = permalinkHeader;
                this.excelHeaders = headers;
            })
            .catch(err => {
                console.error('Excel headers build failed: ' + err);
            });
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/exportAll/exportAll.service.ts